import type { LucideIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

type GtmEmptyStateProps = {
  icon: LucideIcon;
  title: string;
  description: string;
  /** Clarifies GTM Leads ≠ Records → Contacts when relevant */
  footnote?: string;
};

export default function GtmEmptyState({
  icon: Icon,
  title,
  description,
  footnote,
}: GtmEmptyStateProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center py-20 px-6 text-center">
      <Icon className="w-12 h-12 text-gray-300 mb-6" strokeWidth={1.25} />
      <h3 className="text-lg font-semibold text-gray-900 mb-1.5">{t(title)}</h3>
      <p className="text-sm text-gray-500 max-w-md">{t(description)}</p>
      {footnote ? (
        <p className="mt-3 text-xs text-gray-400 max-w-md">{t(footnote)}</p>
      ) : null}
    </div>
  );
}
